/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTemperatureFahrenheit = createReactComponent(
  "temperature-fahrenheit",
  "IconTemperatureFahrenheit",
  [
    ["path", { d: "M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
    ["path", { d: "M13 12l5 0", key: "svg-1" }],
    ["path", { d: "M20 6h-6a1 1 0 0 0 -1 1v11", key: "svg-2" }]
  ]
);

export { IconTemperatureFahrenheit as default };
//# sourceMappingURL=IconTemperatureFahrenheit.js.map
